import { render } from "./TheAuthUserList.vue?vue&type=template&id=585c00a5"
import script from "./TheAuthUserList.vue?vue&type=script&lang=js"
export * from "./TheAuthUserList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__